export default "__VITE_ASSET__CnfdP0F7__"